import type { MapRec } from '@yp/common/identity.ts';
import type { ColorScheme } from '@yp/web.app/styles.ts';

// TODO: https://stackoverflow.com/questions/42584228/how-can-i-define-a-type-for-a-css-color-in-typescript
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export type ColorCodes = /* DaisyColorCode | */ string;

const buttons = {
  PrimaryButton: {
    fg: '--color-primary-content',
    bg: '--color-primary',
    highlight: 'white',
    border: 'black',
  },
  SecondaryButton: {
    fg: '--color-secondary-content',
    bg: '--color-secondary',
    highlight: 'white',
    border: 'black',
  },
  AccentButton: {
    fg: '--color-accent-content',
    bg: '--color-accent',
    highlight: 'white',
    border: 'black',
  },
  NeutralButton: {
    fg: '--color-neutral-content',
    bg: '--color-neutral',
    highlight: 'white',
    border: 'black',
  },
  InfoButton: {
    fg: '--color-info-content',
    bg: '--color-info',
    highlight: 'white',
    border: 'black',
  },
  SuccessButton: {
    fg: '--color-success-content',
    bg: '--color-success',
    highlight: 'white',
    border: 'black',
  },
  WarningButton: {
    fg: '--color-warning-content',
    bg: '--color-warning',
    highlight: 'white',
    border: 'black',
  },
  ErrorButton: {
    fg: '--color-error-content',
    bg: '--color-error',
    highlight: 'white',
    border: 'black',
  },
};

export const ColorMap = {
  ...buttons,
  Home: buttons.PrimaryButton,
  Rsvp: buttons.SecondaryButton,
  Mosaic: buttons.InfoButton,
  Crobble: buttons.AccentButton,
} as const satisfies MapRec<string, ColorScheme<ColorCodes>>;
